// Generated by purs version 0.13.0
"use strict";
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Ritoppu_Model_Direction = require("../Ritoppu.Model.Direction/index.js");
var moveTo = function (dir) {
    return function (pos) {
        return Data_Semiring.add(Data_Semiring.semiringRecord()(Data_Semiring.semiringRecordCons(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))()(Data_Semiring.semiringRecordCons(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))()(Data_Semiring.semiringRecordNil)(Data_Semiring.semiringInt))(Data_Semiring.semiringInt)))(pos)(Ritoppu_Model_Direction.directionDelta(dir));
    };
};
module.exports = {
    moveTo: moveTo
};
